<template>
    <div>
        <el-alert type="warning" show-icon :closable="false">
            <div slot="title">
                <p>1、受结算影响，如果B类用户已经申请结款，则所有待审核的记录将自动过期作废</p>
                <p class="color-danger">2、对于需要寄送实体票的订单，请确保收到退回的票品后再进行审核</p>
            </div>
        </el-alert>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.queryIdType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="场次ID" :value="5"></el-option>                          
                            <el-option label="订单编号" :value="3"></el-option>
                            <el-option label="购买人ID" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.ticketType" placeholder="请选择" size="small">
                        <el-option label="不限制票品性质" value=""></el-option>
                        <el-option label="仅看电子票的" :value="1"></el-option>
                        <el-option label="仅看实体票的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制审核状态" value=""></el-option>
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看待退货的" :value="2"></el-option>
                        <el-option label="仅看待退款的" :value="3"></el-option>
                        <el-option label="仅看退款完成的" :value="4"></el-option>
                        <el-option label="仅看已拒绝的" :value="5"></el-option>
                        <el-option label="仅看已过期的" :value="6"></el-option>
                        <el-option label="仅看审核失败的" :value="7"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.source" placeholder="请选择" size="small">
                        <el-option label="不限制销售渠道" :value="-1"></el-option>
                        <el-option v-for="(item,index) in thirdAccount" :key="index" :label="`仅看${item.thirdName}的`" :value="item.source"></el-option>
						<el-option label="仅看秀动的" value=""></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.refundType" placeholder="请选择" size="small">
				        <el-option label="不限制退票性质" value=""></el-option>
				        <el-option label="仅看演出变动的" :value="0"></el-option>
				        <el-option label="仅看其他原因的" :value="1"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/refundTicketAudit/audit')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-coordinate" size="small" @click="audit(chooseTicket,2,'')">批量通过</el-button>
            <el-button type="danger" icon="el-icon-coordinate" size="small" @click="audit(chooseTicket,3,'')">批量拒绝</el-button>
			<el-button v-if="$utils.have('/refundTicketAudit/reason/list')" type="primary" icon="el-icon-set-up" size="small" @click="set()">配置售后原因</el-button>
			<el-button v-if="$utils.have('/refundTicketAudit/tips/info')"  type="primary" icon="el-icon-edit" size="small" @click="prompt()">配置温馨提示</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" :selectable="selectable"></el-table-column>				
				<el-table-column prop="refundType" label="退票性质" min-width="100">				   
				   <template slot-scope="scope">
					   <div v-if="scope.row.refundType==1">
                            <!-- <span>其他原因 </span> -->
                            <el-popover
                            placement="top-start"
                            title="退票理由"
                            trigger="click"
                            width="400">
                           <el-link :underline="false" type="danger" slot="reference" icon="el-icon-question">其他原因</el-link>
                           <div>理由：<span class="color-info">{{scope.row.applyReason}}</span></div>
                           <div v-if="scope.row.extRemark" class="MT10">补充说明：<span class="color-info">{{scope.row.extRemark}}</span></div>
                           <el-row v-if="scope.row.attachList" class="attach-list" :gutter="10" type="flex">
                                <el-col v-for="(item,index) in scope.row.attachList" :key="index">
                                    <el-image :src="item" fit="cover" :preview-src-list="scope.row.attachList"></el-image>
                                </el-col>
                           </el-row>
                        </el-popover>
                       </div>
					   <span v-else-if="scope.row.refundType==0">演出变动</span>		       
				   </template>
				</el-table-column>				
				<el-table-column prop="source" label="销售渠道"></el-table-column>                
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope" >
                        <el-popover
                            v-if="scope.row.status == 5" 
                            placement="top-start"
                            title="拒绝理由"
                            trigger="click"
                            :content="scope.row.remark"
                            width="400">
                           <el-link :underline="false" type="danger" slot="reference" icon="el-icon-question">{{status.get(scope.row.status)}} </el-link>
                        </el-popover>
                        <span v-else>{{status.get(scope.row.status)}} </span>
                    </template>
                </el-table-column>
                <el-table-column prop="applyTime" label="申请时间" min-width="150"></el-table-column>
               <!-- <el-table-column prop="applyReason" label="申请原因" min-width="200" show-overflow-tooltip></el-table-column>-->
				<el-table-column prop="isTransfer" label="是否转赠">
					<template slot-scope="scope">
						{{scope.row.isTransfer == 1 ? '有过转赠' : '没有转赠'}}					   
					</template>
				</el-table-column>
                <el-table-column prop="ticketTypeStr" label="票品性质"></el-table-column>
                <el-table-column prop="orderStauts" label="订单状态">
                    <template slot-scope="scope">
                       {{orderStatus.get(scope.row.orderStauts)}}
                    </template>
                </el-table-column>
                <el-table-column prop="orderId" label="订单ID"></el-table-column>
                <el-table-column prop="sn" label="订单编号" min-width="140" >
					<template slot-scope="scope">
					    <el-link class="ellipsis" :href="`/activityManage/order/edit/${scope.row.orderId}`" target="_blank" type="primary">{{scope.row.sn}}</el-link>
					</template>
				</el-table-column>
                <el-table-column label="总价" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.totalAmountStr}}</p>
						<p>乐迷服务费：{{scope.row.userServiceFeeStr}}</p>
					</template>
				</el-table-column>
                <el-table-column label="优惠" min-width="140" >
					<template slot-scope="scope">
						<p>优惠券：{{scope.row.couponDiscountView}}</p>
						<p>立减金额：{{scope.row.randomDiscountView}}</p>
						<p>其它优惠：{{scope.row.otherDiscountView}}</p>
					</template>
				</el-table-column>
                <el-table-column label="实际支付" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.paidAmountStr}}</p>
						<p>乐迷服务费：{{scope.row.userServiceFeeStr}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="refundFeeRatioStr" label="申请时退票手续费（比例）" min-width="140">
					<template slot-scope="scope">
						{{scope.row.refundFeeStr}} （{{scope.row.refundFeeRatioStr}}）
					</template>
				</el-table-column>
				<el-table-column prop="refundAmountStr" label="申请退款金额" min-width="100"></el-table-column>
				
                <el-table-column prop="customerId" label="购买人ID"></el-table-column>
                <el-table-column prop="telephone" label="联系手机" min-width="130">
                    <template slot-scope="scope">
                        {{scope.row.areaCode && scope.row.telephone ? '+'+scope.row.areaCode.split('_')[0] : ''}} {{scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" show-overflow-tooltip min-width="250">
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="`${sswap}/pages/activity/detail/detail?activityId=${scope.row.activityId}`" target="_blank"  type="primary">{{scope.row.activityName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.isShowAuditBtn == 1  && $utils.have('/refundTicketAudit/audit')"
                            type="text"
                            size="small"
                            icon="el-icon-coordinate"
                            @click="edit(scope.row.id,'',scope.row)"
                            >审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <Audit ref="audit" @onUpdate="getDataList"></Audit>
		<Prompt ref="Prompt" :data="dataPrompt"  @onUpdate="getPrompt" ></Prompt>    
    </div>
</template>

<script>
import Audit from './components/audit';
import Prompt from './components/prompt';
import {fetchThirdAccount} from '@/assets/js/commonApi';
const defaultParams = {
    pageNo:1,
    queryIdType:1,
    value:'',
    status:1,
    ticketType:'',
    source: -1,
	refundType:''
}
export default {
    components:{Audit,Prompt},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize:this.$pageSizes[0],
                status: parseInt(this.$route.query.status || 1),
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            chooseTicket:null,
            thirdAccount:[],
			dataPrompt:'',
        }
    },
    computed:{
        status(){
            return new Map([
                [1,'待审核'],
                [2,'待退货'],
                [3,'待退款'],
                [4,'退款完成'],
                [5,'已拒绝'],
                [6,'已过期'],
                [7,'审核失败']
            ])
        },
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
				[7,'已取消'],
            ])
        }
    },
    mounted() {
        this.getDataList();
        this.getThirdAccount();
		if(this.$utils.have('/refundTicketAudit/tips/info')){
			this.getPrompt()
		}
		
    },
    methods:{
        //获取第三方平台
        getThirdAccount(){
            fetchThirdAccount({isThird:1})
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.thirdAccount = result.thirdAccounts || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/refundTicketAudit/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		// applyReason(val){
		// 	this.$alert(val, '退票理由', {confirmButtonText: '关闭', dangerouslyUseHTMLString: true, });
		// },
        handleSelectionChange(val){
            //this.ids = val.map( v => v.id );
			this.chooseTicket = val
        },
        selectable(row){
            return row.status === 1;
        },
        edit(id,status,data){
            const _ids = [id];
            this.audit(_ids,'',data);
        },
        audit(chooseTicket,status,data){		
			var	ids = chooseTicket ? chooseTicket.map( v => v.id ) :null;
			if( !ids || ids.length < 2 && status != ''){
				this.$message.error('请勾选需要批量审核的单据且大于等于2条');
			}else{
				this.$refs.audit.show(chooseTicket,status,data);
			}
        },
		//配置售后原因
		set(){
			this.$router.push('/activityManage/refundTicketAudit/aftersales');
		},
		prompt(){
			this.$refs.Prompt.show();
			
		},
		getPrompt(){
		   this.$request({
			   url: "/refundTicketAudit/tips/info",
			   method: "POST",
			   data: {},
		   })
			   .then((res) => {
				   const { state, msg, result } = res.data;
				   if (state == 1 && result) {
					   this.dataPrompt = result || '';		               
					   
				   } else {
					   this.$message.error(msg || "请求失败");
				   }
			   })
			   .catch(() => {
				   this.$message.error("请求错误");
			   })
			   .finally(() => {
				   this.listLoading = false;
			   });
		},
    }
}
</script>
<style lang="scss" scoped>
.attach-list{
    .el-col{
        margin-top: 10px;
        width: 80px;
        height: 80px;
        .el-image{
            width: 100%;
            height: 100%;
        }
    }
}
</style>